import { getDefaultConfig } from '@rainbow-me/rainbowkit'
import { defineChain } from 'viem'

// Ethereum Classic Mainnet
// Note: ETC uses original Multicall contracts, NOT Multicall3
// Do not add multicall3 config - it will cause viem to use wrong function signatures
export const classic = defineChain({
  id: 61,
  name: 'Ethereum Classic',
  nativeCurrency: {
    name: 'Ether',
    symbol: 'ETC',
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: ['https://etc.rivet.link'],
    },
  },
  blockExplorers: {
    default: {
      name: 'Blockscout',
      url: 'https://etc.blockscout.com',
    },
  },
})

// Mordor Testnet
// Note: Uses original Multicall, not Multicall3
export const mordor = defineChain({
  id: 63,
  name: 'Mordor Testnet',
  nativeCurrency: {
    name: 'Mordor Ether',
    symbol: 'METC',
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: ['https://rpc.mordor.etccooperative.org'],
    },
  },
  blockExplorers: {
    default: {
      name: 'Blockscout',
      url: 'https://etc-mordor.blockscout.com',
    },
  },
  testnet: true,
})

// Determine which chains to use based on environment
export const chains = import.meta.env.VITE_TESTNET_ONLY === 'true'
  ? [mordor] as const
  : [classic, mordor] as const

export const config = getDefaultConfig({
  appName: 'ETCswap',
  projectId: import.meta.env.VITE_WALLETCONNECT_PROJECT_ID || '',
  chains,
})

// Helper to get chain by ID
export function getChainById(chainId: number) {
  if (chainId === 61) return classic
  if (chainId === 63) return mordor
  return undefined
}

// Type for supported chain IDs
export type SupportedChainId = 61 | 63

// List of supported chain IDs for runtime checks
export const SUPPORTED_CHAIN_IDS = [61, 63] as const

// V2 Contract addresses
export const V2_CONTRACTS = {
  [61]: {
    factory: '0x0307cd3D7DA98A29e6Ed0D2137be386Ec1e4Bc9C' as const,
    router: '0x79Bf07555C34e68C4Ae93642d1007D7f908d60F5' as const,
    multicall: '0x900cD941a2451471BC5760c3d69493Ac57aA9698' as const,
    WETC: '0x1953cab0E5bFa6D4a9BaD6E05fD46C1CC6527a5a' as const,
    INIT_CODE_HASH: '0xb5e58237f3a44220ffc3dfb989e53735df8fcd9df82c94b13105be8380344e52' as const,
  },
  [63]: {
    factory: '0x212eE1B5c8C26ff5B2c4c14CD1C54486Fe23ce70' as const,
    router: '0x6d194227a9A1C11f144B35F96E6289c5602Da493' as const,
    multicall: '0x41Fa0143ea4b4d91B41BF23d0A03ed3172725C4B' as const,
    WETC: '0x1953cab0E5bFa6D4a9BaD6E05fD46C1CC6527a5a' as const,
    INIT_CODE_HASH: '0x4d8a51f257ed377a6ac3f829cd4226c892edbbbcb87622bcc232807b885b1303' as const,
  },
} as const
